import "./App.css";
import MainPage from "./components/MainPage";
import ParticlesBg from "particles-bg";
import EasterEggOverlay from "./components/EasterEggOverlay";


function App() {
  let logo = require("./logo.svg");
  return (
    <div className="mainPage">
      <div className="header">
        <p className="headerLogo">
          <img className="headerLogo" src={logo.default} alt="Technisys logo" />
        </p>
        <p className="headerFiller"> </p>
        <p className="headerButton">
          <a href="mailto:contact@technisys.ch">Contact</a>
        </p>
      </div>
      <ParticlesBg
        type="cobweb"
        bg={true}
        config={{ body: "TEHH", num: 1000 }}
      />
      <EasterEggOverlay />

      <div className="firstView">
        <img className="firstViewLogo" src={logo.default} alt="Technisys logo" />
        <p className="shortpitch">
          Your web &amp; software partner, from idea to production.
        </p>
        <p className="nudge">· · · move your mouse to explore · · ·</p>
      </div>
    </div>
  );
}


export default App;
